<template>
<div :class="$style.wrapper" v-if="showTable">
    <div :class="[$style.wrapper__inner, 'gnzs-1c-scroll-table-wrapper']">
        <div 
            :style="{ 'margin-left': tableOffset + 'px' }"
            :class="[$style.draggable, 'gnzs-1c-scroll-table-draggable']">
            <ProductsTable />
        </div>
    </div>
    <ProductsTableScroller />
</div>    
<ProductsTable :class="$style.fullwidth" v-else/>
</template>

<script>
import $ from 'jquery'
import {mapActions, mapGetters} from 'vuex'
import ProductsTable from './ProductsTable'
import ProductsTableScroller from './ProductsTableScroller'

export default {
    computed: {
        ...mapGetters({
            minOffset: 'table/minOffset',
            tableOffset: 'table/tableOffset',
            showTable: 'table/showTable'
        }),
        minOffsetReal(){
            let wrapper = $(`.gnzs-1c-scroll-table-wrapper`)
            let draggable = $(`.gnzs-1c-scroll-table-draggable`)
            return this.minOffset(wrapper,draggable)         
        },
    },
    methods: {
        ...mapActions({
            setValue: 'table/setValue',
            calc: 'table/calc'
        })
    },
    components: {
        ProductsTable,
        ProductsTableScroller
    },
    mounted(){
        this.setValue({key:'isWrapperMounted', value: true})
        let wrapper = $(`.gnzs-1c-scroll-table-wrapper`)
        let draggable = $(`.gnzs-1c-scroll-table-draggable`)
        setTimeout(() => this.calc({wrapper, draggable}), 100)
    }
}
</script>


<style lang="scss" module>
    @import './ProductsTable.scss';
</style>